import ManageWorkflows from '../pages/manageWorkflows.js';
import ManageWorkflowsHelpPanel from '../helpPanelContents/manageWorkflowsHelpPanel';
import React from 'react';
import { useAuth } from '../context/AuthContext.js';
import { useRoleMatrix, toCanonicalRole } from '../context/RoleMatrixContext';
import { Redirect, Route, Switch } from 'react-router-dom';
import ModifyWorkflow from '../pages/modifyWorkflow.js';
import {
  ContentLayout,
  Header,
  BreadcrumbGroup,
  Hotspot,
  Link,
  SpaceBetween,
  Button,
  Box // Import Box component
} from '@cloudscape-design/components';
import AdminDashboard from '../pages/home/HomeDashboardPage.jsx';
// Remove the old manageAppointments import

import UserManagementDashboard from '../pages/manageUsers.js';
import ModifyLocation from '../pages/modifyLocation.js';
import BookAppointmentQ1 from '../previews/bookAppointmentQ1.js';
import BookAppointmentQ2 from '../previews/bookAppointmentQ2.js';
import BookAppointmentQ3 from '../previews/bookAppointmentQ3.js';
import BookAppointmentQ4 from '../previews/bookAppointmentQ4.js';
import BookAppointmentQ5 from '../previews/bookAppointmentQ5.js';
import BookAppointmentQ6 from '../previews/bookAppointmentQ6.js';
import BookAppointmentQ7 from '../previews/bookAppointmentQ7.js';
import BookAppointmentQ8 from '../previews/bookAppointmentQ8.js';
import ConfigurationSettings from '../pages/configurationSettings.js';
import DataAndResultsDashboard from '../pages/reporting/DataAndResultsDashboard.jsx';
import RegionalSnapshotDashboard from '../pages/reporting/RegionalSnapshotDashboard.jsx';
import OperationsAndTimelinessDashboard from '../pages/reporting/OperationsAndTimelinessDashboard.jsx';
import ManageNotifications from '../pages/manageNotifications.js';
import { ManageNotificationsHelp } from '../helpPanelContents/manageNotificationsHelp.js';
import TemplateEditorDashboard from '../pages/templateEditorDashboard.js';
import TemplateEditorDashboardHelp from '../helpPanelContents/templateEditorDashboardHelp.js';
import RegionalSnapshotDashboardHelp from '../helpPanelContents/regionalSnapshotDashboardHelp.js';
import ModifyComponent from '../pages/modifyIntakeStep.js'; // Import the new component
import ModifyIntakeStepHelp from '../helpPanelContents/modifyIntakeStep.js'; // Renamed help panel content
import ManageSecurityOptions from '../pages/manageSecurityOptions.js'; // Import the renamed component
import AccessControlDashboard from '../pages/accessControlDashboard.js';
import ManageIntakeSteps from '../pages/manageIntakeSteps.js'; // Import the renamed component
import ManageIntakeStepsHelpPanel from '../helpPanelContents/manageIntakeStepsHelpPanel'; // Correct the import path
import CaseAssignmentDashboard from '../pages/caseAssignmentDashboard.js'; // Import the new component
import ApplicationCaseDashboard from '../pages/applicationCaseDashboard.js'; // Import the new component
import AppealsEntry from '../pages/Caseworking/AppealsEntry.jsx';
import ManualApplicationIntakePage from '../pages/intake/ManualApplicationIntakePage.jsx';
import ClientFileImportDashboard from '../pages/imports/ClientFileImportDashboard.jsx';
import CaseAssignmentDashboardHelp from '../helpPanelContents/caseAssignmentDashboardHelp.js';
import ApplicationCaseDashboardHelp from '../helpPanelContents/applicationCaseDashboardHelp.js';
import ManualApplicationIntakeHelp from '../helpPanelContents/manualApplicationIntakeHelp.js';
import ClientFileImportDashboardHelp from '../helpPanelContents/clientFileImportDashboardHelp.js';
import NWACHubManagementDashboard from '../pages/nwacHubManagement.js'; // Import the NWAC Hub Management dashboard
import UploadConfigDashboard from '../pages/uploadConfigDashboard.js';
import EventCaptureDashboard from '../pages/configuration/EventCaptureDashboard.js';
import ApplicantWatchlistPage from '../pages/configuration/ApplicantWatchlistPage.jsx';
import QueryEditorDashboard from '../pages/configuration/QueryEditorDashboard.js';
import FinanceOverviewPage from '../pages/finance/FinanceOverviewPage.jsx';
import FinanceSalariesPage from '../pages/finance/FinanceSalariesPage.jsx';
import FinanceExpensesPage from '../pages/finance/FinanceExpensesPage.jsx';
import FinanceExpensesHelp from '../helpPanelContents/financeExpensesHelp.js';
import RemindersDashboard from '../pages/reminders/RemindersDashboard.jsx';
import RemindersHelp from '../helpPanelContents/remindersHelp.js';
import FinanceOverviewHelp from '../helpPanelContents/financeOverviewHelp.js';
import FinanceBudgetsPage from '../pages/finance/FinanceBudgetsPage.jsx';
import PublishedBudgetsPage from '../pages/finance/PublishedBudgetsPage.jsx';
import FinanceAllocationsPage from '../pages/finance/FinanceAllocationsPage.jsx';
import FinanceReconciliationPage from '../pages/finance/FinanceReconciliationPage.jsx';
import FinanceReportsPage from '../pages/finance/FinanceReportsPage.jsx';
import FinanceMonitoringPage from '../pages/finance/FinanceMonitoringPage.jsx';
import FinanceForecastingPage from '../pages/finance/FinanceForecastingPage.jsx';
import FinanceSettingsPage from '../pages/finance/FinanceSettingsPage.jsx';
import FinancePaymentsPage from '../pages/finance/FinancePaymentsPage.jsx';
import FinanceBudgetsHelp from '../helpPanelContents/financeBudgetsHelp.js';
import FinanceBudgetPlanningHelp from '../helpPanelContents/financeBudgetPlanningHelp.js';
import FinanceSalariesHelp from '../helpPanelContents/financeSalariesHelp.js';
import FinanceAllocationsHelp from '../helpPanelContents/financeAllocationsHelp.js';
import FinanceReconciliationHelp from '../helpPanelContents/financeReconciliationHelp.js';
import FinanceReportsHelp from '../helpPanelContents/financeReportsHelp.js';
import FinanceMonitoringHelp from '../helpPanelContents/financeMonitoringHelp.js';
import FinanceForecastingHelp from '../helpPanelContents/financeForecastingHelp.js';
import FinancePaymentsHelp from '../helpPanelContents/financePaymentsHelp.js';
import ContactCommunicationsDashboard from '../pages/contact/ContactCommunicationsDashboard.jsx';
import ContactCommunicationsHelp from '../helpPanelContents/contactCommunicationsHelp.js';
import ApplicantWatchlistHelp from '../helpPanelContents/applicantWatchlistHelp.js';
import QueryEditorHelp from '../helpPanelContents/queryEditorHelp.js';
import UserManagementHelp from '../helpPanelContents/userManagementHelp.js';
import MessagesDashboardPage from '../pages/messages/MessagesDashboardPage.jsx';
import PortfolioDashboardPage from '../pages/Caseworking/PortfolioDashboardPage.jsx';
import PortfolioDashboardHelp from '../helpPanelContents/portfolioDashboardHelp.js';
import CaseWorkspacePage from '../pages/Caseworking/CaseWorkspacePage.jsx';
import CaseWorkspaceHelp from '../helpPanelContents/caseWorkspaceHelp.js';
import ProgramPaymentsPage from '../pages/Caseworking/ProgramPaymentsPage.jsx';
import JobBankSearchPage from '../pages/integrations/JobBankSearchPage.jsx';
import JobBankSearchHelp from '../helpPanelContents/jobBankSearchHelp.js';
import EsdcSubmissionsOverviewPage from '../pages/esdc/EsdcSubmissionsOverviewPage.jsx';
import EsdcParticipantSubmissionsPage from '../pages/esdc/EsdcParticipantSubmissionsPage.jsx';
import EsdcReportingPackagesPage from '../pages/esdc/EsdcReportingPackagesPage.jsx';
import ParticipantWorkspacePage from '../pages/esdc/ParticipantWorkspacePage.jsx';
import EsdcOverviewHelp from '../helpPanelContents/esdcOverviewHelp.js';
import EsdcParticipantsHelp from '../helpPanelContents/esdcParticipantsHelp.js';
import EsdcReportingHelp from '../helpPanelContents/esdcReportingHelp.js';
import EsdcSubmissionDashboardHelp from '../helpPanelContents/esdcSubmissionDashboardHelp.js';
import DataAndResultsDashboardHelp from '../helpPanelContents/dataAndResultsDashboardHelp.js';
import OperationsAndTimelinessDashboardHelp from '../helpPanelContents/operationsAndTimelinessDashboardHelp.js';
import DocumentationLibrary from '../pages/documentation/DocumentationLibrary.jsx';
import HomeDashboardHelp from '../helpPanelContents/homeDashboardHelp.js';
import BugsChangeRequestsDashboard from '../pages/support/BugsChangeRequestsDashboard.jsx';
import TutorialsDashboardPage from '../pages/support/TutorialsDashboardPage.jsx';
import TutorialsDashboardHelp from '../helpPanelContents/tutorialsDashboardHelp.js';
import MinimumServiceDashboard from '../pages/reporting/MinimumServiceDashboard.jsx';
import MinimumServiceHelp from '../helpPanelContents/minimumServiceHelp.js';
import ActivityReportDashboard from '../pages/reporting/ActivityReportDashboard.jsx';
import ActivityReportHelp from '../helpPanelContents/activityReportHelp.js';
import HomeSystemAdminFeedbackQueueHelp from '../helpPanelContents/homeSystemAdminFeedbackQueueHelp.js';

function Guard({
  children,
  roles,
  path,
  renderContent,
  waitForMatrix = false,
}) {
  const { isAuthenticated, role, signIn } = useAuth();
  const { roleMatrix, isLoading: roleMatrixLoading } = useRoleMatrix();

  const renderGuardContent = (Component, breadcrumbs, headerText) => {
    if (typeof renderContent === 'function') {
      return renderContent(Component, breadcrumbs, headerText);
    }
    return (
      <ContentLayout
        header={<Header variant="h1">{headerText}</Header>}
      >
        <BreadcrumbGroup items={breadcrumbs} />
        <Box padding={{ bottom: 'm' }} />
        <Component />
      </ContentLayout>
    );
  };

  if (!isAuthenticated) {
    const AuthRequired = () => (
      <div style={{ padding: 24 }}>
        <p style={{ marginBottom: 12 }}>Please sign in to access this page.</p>
        <Button variant="primary" onClick={signIn}>Sign in</Button>
      </div>
    );
    return renderGuardContent(AuthRequired, [{ text: 'Home', href: '/' }], 'Authentication required');
  }
  if (!roles && (roleMatrixLoading || !roleMatrix)) {
    return waitForMatrix ? <Box role="status">Loading access permissions...</Box> : children;
  }
  const canonicalRole = toCanonicalRole(role);
  const allowed = (() => {
    if (Array.isArray(roles) && roles.length) return roles;
    if (path && roleMatrix?.routes) {
      const direct = roleMatrix.routes[path];
      if (direct) return direct;
    }
    return null;
  })();
  if (allowed) {
    if (!canonicalRole || !allowed.includes(canonicalRole)) {
      const AccessDenied = () => (<div style={{ padding: 24 }}>You do not have permission to view this page.</div>);
      return renderGuardContent(AccessDenied, [{ text: 'Home', href: '/' }], 'Access denied');
    }
  } else if (roleMatrix?.default === 'deny') {
    const AccessDenied = () => (<div style={{ padding: 24 }}>You do not have permission to view this page.</div>);
    return renderGuardContent(AccessDenied, [{ text: 'Home', href: '/' }], 'Access denied');
  }
  return children;
}

const AppRoutes = ({
  toggleHelpPanel,
  updateBreadcrumbs,
  setSplitPanelOpen,
  splitPanelOpen,
  setSplitPanelSize,
  splitPanelSize,
  setAvailableItems,
  breadcrumbs,
  helpMessages,
}) => {
  const renderContent = (
    Component,
    breadcrumbs,
    headerText,
    helpKey,
    actions = null,
    context = "",
    headerDescription = "",
    headerHotspotId = null,
    headerInfoHotspotId = null
  ) => (
    <ContentLayout
      header={
        <div style={{ position: 'relative' }}>
          {(() => {
            const infoLink = (
              <Link variant="info" onClick={() => toggleHelpPanel(helpKey, headerText, context)}>Info</Link>
            );
            const headerInfo = headerInfoHotspotId ? (
              <span style={{ display: 'inline-flex' }}>
                <Hotspot hotspotId={headerInfoHotspotId} direction="bottom">
                  <span style={{ display: 'inline-flex' }}>{infoLink}</span>
                </Hotspot>
              </span>
            ) : infoLink;
            return (
          <Header
            variant="h1"
            description={headerDescription || undefined}
                info={headerInfo}
            actions={actions} // Attach actions here
          >
            {headerText}
          </Header>
            );
          })()}
          {headerHotspotId ? (
            <div style={{ position: 'absolute', left: '-12px', top: '22px' }}>
              <Hotspot hotspotId={headerHotspotId} direction="bottom">
                <span style={{ display: 'inline-block', width: '1px', height: '1px' }} />
              </Hotspot>
            </div>
          ) : null}
        </div>
      }
    >
      <BreadcrumbGroup items={breadcrumbs} />
      <Box padding={{ bottom: 'm' }} /> {/* Add space below BreadcrumbGroup */}
      <Component
        toggleHelpPanel={toggleHelpPanel}
        updateBreadcrumbs={updateBreadcrumbs}
        setSplitPanelOpen={setSplitPanelOpen}
        splitPanelOpen={splitPanelOpen}
        setSplitPanelSize={setSplitPanelSize}
        splitPanelSize={splitPanelSize}
        setAvailableItems={setAvailableItems}
      />
    </ContentLayout>
  );

  return (
    <Switch>
      <Route path="/manage-workflows">
        <Guard path="/manage-workflows" renderContent={renderContent}>
          {renderContent(
            ManageWorkflows,
            [
              { text: 'Home', href: '/' },
              { text: 'Intake Editor', href: '/manage-components' },
              { text: 'Manage Workflows', href: '/manage-workflows' }
            ],
            'Manage Workflows',
            <ManageWorkflowsHelpPanel />
          )}
        </Guard>
      </Route>

      <Route path="/modify-workflow">
        <Guard path="/modify-workflow">
          {renderContent(
            ModifyWorkflow,
            [
              { text: 'Home', href: '/' },
              { text: 'Manage Workflows', href: '/manage-workflows' },
              { text: 'Modify Workflow', href: '/modify-workflow' }
            ],
            'Modify Workflow',
            'modifyWorkflow'
          )}
        </Guard>
      </Route>

      <Route path="/modify-hub/:id">
        <Guard path="/modify-hub/:id">
          {renderContent(
            ModifyLocation,
            [{ text: 'Home', href: '/' }, { text: 'NWAC Hub Management', href: '/nwac-hub-management' }, { text: 'Modify Hub', href: '/modify-hub/:id' }],
            'Manage NWAC Hub',
            'modifyHub'
          )}
        </Guard>
      </Route>

      <Route path="/user-management-dashboard">
        <Guard path="/user-management-dashboard">
          {renderContent(
            UserManagementDashboard,
            [{ text: 'Home', href: '/' }, { text: 'User Management', href: '/user-management-dashboard' }],
            'User Management',
            <UserManagementHelp />,
            null,
            UserManagementHelp.aiContext
          )}
        </Guard>
      </Route>

      <Route path="/book-appointment-q1">
        {renderContent(
          BookAppointmentQ1,
          [{ text: 'Home', href: '/' }, { text: 'Book Appointment Q1', href: '/book-appointment-q1' }],
          'Book Appointment Q1',
          'bookAppointmentQ1'
        )}
      </Route>

      <Route path="/book-appointment-q2">
        {renderContent(
          BookAppointmentQ2,
          [{ text: 'Home', href: '/' }, { text: 'Book Appointment Q2', href: '/book-appointment-q2' }],
          'Book Appointment Q2',
          'bookAppointmentQ2'
        )}
      </Route>

      <Route path="/book-appointment-q3">
        {renderContent(
          BookAppointmentQ3,
          [{ text: 'Home', href: '/' }, { text: 'Book Appointment Q3', href: '/book-appointment-q3' }],
          'Book Appointment Q3',
          'bookAppointmentQ3'
        )}
      </Route>

      <Route path="/book-appointment-q4">
        {renderContent(
          BookAppointmentQ4,
          [{ text: 'Home', href: '/' }, { text: 'Book Appointment Q4', href: '/book-appointment-q4' }],
          'Book Appointment Q4',
          'bookAppointmentQ4'
        )}
      </Route>

      <Route path="/book-appointment-q5">
        {renderContent(
          BookAppointmentQ5,
          [{ text: 'Home', href: '/' }, { text: 'Book Appointment Q5', href: '/book-appointment-q5' }],
          'Book Appointment Q5',
          'bookAppointmentQ5'
        )}
      </Route>

      <Route path="/book-appointment-q6">
        {renderContent(
          BookAppointmentQ6,
          [{ text: 'Home', href: '/' }, { text: 'Book Appointment Q6', href: '/book-appointment-q6' }],
          'Book Appointment Q6',
          'bookAppointmentQ6'
        )}
      </Route>

      <Route path="/book-appointment-q7">
        {renderContent(
          BookAppointmentQ7,
          [{ text: 'Home', href: '/' }, { text: 'Book Appointment Q7', href: '/book-appointment-q7' }],
          'Book Appointment Q7',
          'bookAppointmentQ7'
        )}
      </Route>

      <Route path="/book-appointment-q8">
        {renderContent(
          BookAppointmentQ8,
          [{ text: 'Home', href: '/' }, { text: 'Book Appointment Q8', href: '/book-appointment-q8' }],
          'Book Appointment Q8',
          'bookAppointmentQ8'
        )}
      </Route>

      <Route path="/configuration-settings">
        <Guard path="/configuration-settings">
          {renderContent(
            ConfigurationSettings,
            [{ text: 'Home', href: '/' }, { text: 'Configuration Settings', href: '/configuration-settings' }],
            'Configuration Settings',
            'configurationSettings',
            (
              <SpaceBetween size="xs" direction="horizontal">
                <Button
                  iconName="add-plus"
                  onClick={() =>
                    window.dispatchEvent(new CustomEvent('configuration-dashboard:openPalette'))
                  }
                >
                  Add widget
                </Button>
                <Button
                  iconName="refresh"
                  onClick={() =>
                    window.dispatchEvent(new CustomEvent('configuration-dashboard:resetLayout'))
                  }
                >
                  Reset layout
                </Button>
              </SpaceBetween>
            )
          )}
        </Guard>
      </Route>

      <Route path="/configuration/query-editor">
        <Guard path="/configuration/query-editor">
          {renderContent(
            QueryEditorDashboard,
            [
              { text: 'Home', href: '/' },
              { text: 'Configuration', href: '/configuration-settings' },
              { text: 'Query Editor', href: '/configuration/query-editor' }
            ],
            'Query Editor',
            <QueryEditorHelp />,
            (
              <SpaceBetween size="xs" direction="horizontal">
                <Button
                  iconName="add-plus"
                  onClick={() => window.dispatchEvent(new CustomEvent('queryEditor:openPalette'))}
                >
                  Add widget
                </Button>
                <Button
                  iconName="refresh"
                  onClick={() => window.dispatchEvent(new CustomEvent('queryEditor:resetLayout'))}
                >
                  Reset layout
                </Button>
              </SpaceBetween>
            ),
            QueryEditorHelp.aiContext
          )}
        </Guard>
      </Route>

      <Route path="/configuration/events">
        <Guard roles={['System Administrator']} path="/configuration/events">
          {renderContent(
            EventCaptureDashboard,
            [
              { text: 'Home', href: '/' },
              { text: 'Configuration', href: '/configuration-settings' },
              { text: 'Event Capture', href: '/configuration/events' }
            ],
            'Event Capture Configuration',
            'eventCapture'
          )}
        </Guard>
      </Route>

      <Route path="/configuration/applicant-watchlist">
        <Guard path="/configuration/applicant-watchlist">
          {renderContent(
            ApplicantWatchlistPage,
            [
              { text: 'Home', href: '/' },
              { text: 'Configuration', href: '/configuration-settings' },
              { text: 'Applicant Watchlist', href: '/configuration/applicant-watchlist' }
            ],
            'Applicant Watchlist',
            <ApplicantWatchlistHelp />,
            null,
            ApplicantWatchlistHelp.aiContext,
            'Review and maintain the SIN-based applicant watchlist used to flag new applications.'
          )}
        </Guard>
      </Route>

      <Route path="/admin/upload-config">
        <Guard path="/admin/upload-config">
          {renderContent(
            UploadConfigDashboard,
            [
              { text: 'Home', href: '/' },
              { text: 'Configuration', href: '/configuration-settings' },
              { text: 'File Upload Config', href: '/admin/upload-config' }
            ],
            'File Upload Configuration',
            'fileUploadConfig'
          )}
        </Guard>
      </Route>

      <Redirect
        exact
        from="/reporting-and-monitoring-dashboard"
        to="/reporting/operations-and-timeliness"
      />

      <Route path="/reminders">
        <Guard path="/reminders" waitForMatrix>
          {renderContent(
            RemindersDashboard,
            [{ text: 'Home', href: '/' }, { text: 'Reminders', href: '/reminders' }],
            'Reminders',
            <RemindersHelp />,
            <SpaceBetween direction="horizontal" size="s">
              <Button iconName="add-plus" onClick={() => window.dispatchEvent(new CustomEvent('reminders:openPalette'))}>Add widget</Button>
              <Button iconName="refresh" onClick={() => window.dispatchEvent(new CustomEvent('reminders:resetLayout'))}>Reset layout</Button>
            </SpaceBetween>,
            RemindersHelp.aiContext
          )}
        </Guard>
      </Route>

      <Route path="/manage-notifications">
        <Guard path="/manage-notifications">
          {renderContent(
            ManageNotifications,
            [{ text: 'Home', href: '/' }, { text: 'Manage Notifications', href: '/manage-notifications' }],
            'Manage Notifications',
            <ManageNotificationsHelp />
          )}
        </Guard>
      </Route>

      <Route path="/reporting/activity-report">
        <Guard path="/reporting/activity-report">
          {renderContent(
            ActivityReportDashboard,
            [{ text: 'Home', href: '/' }, { text: 'Reporting' }, { text: 'Activity Report', href: '/reporting/activity-report' }],
            'Activity Report',
            <ActivityReportHelp />,
            <SpaceBetween size="xs" direction="horizontal">
              <Button iconName="add-plus" onClick={() => window.dispatchEvent(new CustomEvent('activityReport:openPalette'))}>Add widget</Button>
              <Button iconName="refresh" onClick={() => window.dispatchEvent(new CustomEvent('activityReport:resetLayout'))}>Reset layout</Button>
            </SpaceBetween>,
            ActivityReportHelp.aiContext,
            'Review program activity for a fiscal year or quarter.'
          )}
        </Guard>
      </Route>

      <Route path="/reporting/minimum-service-level">
        <Guard path="/reporting/minimum-service-level">
          {renderContent(
            MinimumServiceDashboard,
            [{ text: 'Home', href: '/' }, { text: 'Reporting' }, { text: 'Minimum Service Level', href: '/reporting/minimum-service-level' }],
            'Minimum Service Level',
            <MinimumServiceHelp />,
            <SpaceBetween size="xs" direction="horizontal">
              <Button iconName="add-plus" onClick={() => window.dispatchEvent(new CustomEvent('minimumService:openPalette'))}>Add widget</Button>
              <Button iconName="refresh" onClick={() => window.dispatchEvent(new CustomEvent('minimumService:resetLayout'))}>Reset layout</Button>
            </SpaceBetween>,
            MinimumServiceHelp.aiContext,
            'Review recorded inquiries and unfunded services.'
          )}
        </Guard>
      </Route>

      <Route path="/reporting/data-and-results">
        <Guard path="/reporting/data-and-results">
          {renderContent(
            DataAndResultsDashboard,
            [
              { text: 'Home', href: '/' },
              { text: 'Reporting' },
              { text: 'Data and Results', href: '/reporting/data-and-results' }
            ],
            'Data and Results',
            <DataAndResultsDashboardHelp />,
            (
              <SpaceBetween size="xs" direction="horizontal">
                <Button
                  iconName="add-plus"
                  onClick={() =>
                    window.dispatchEvent(new CustomEvent('dataAndResults:openPalette'))
                  }
                >
                  Add section
                </Button>
                <Button
                  iconName="refresh"
                  onClick={() =>
                    window.dispatchEvent(new CustomEvent('dataAndResults:resetLayout'))
                  }
                >
                  Reset layout
                </Button>
              </SpaceBetween>
            ),
            DataAndResultsDashboardHelp.aiContext,
            'Review annual results, quarterly submissions, and reporting notes for the selected fiscal year.'
          )}
        </Guard>
      </Route>

      <Route path="/reporting/operations-and-timeliness">
        <Guard path="/reporting/operations-and-timeliness">
          {renderContent(
            OperationsAndTimelinessDashboard,
            [
              { text: 'Home', href: '/' },
              { text: 'Reporting' },
              {
                text: 'Operations Report',
                href: '/reporting/operations-and-timeliness'
              }
            ],
            'Operations Report',
            <OperationsAndTimelinessDashboardHelp />,
            (
              <SpaceBetween size="xs" direction="horizontal">
                <Button
                  iconName="add-plus"
                  onClick={() =>
                    window.dispatchEvent(new CustomEvent('operationsTimeliness:openPalette'))
                  }
                >
                  Add section
                </Button>
                <Button
                  iconName="refresh"
                  onClick={() =>
                    window.dispatchEvent(new CustomEvent('operationsTimeliness:resetLayout'))
                  }
                >
                  Reset layout
                </Button>
              </SpaceBetween>
            ),
            OperationsAndTimelinessDashboardHelp.aiContext,
            'Review funding, workload, backlog and monthly operational trends.'
          )}
        </Guard>
      </Route>

      <Route path="/reporting/regional-snapshot">
        <Guard path="/reporting/regional-snapshot">
          {renderContent(
            RegionalSnapshotDashboard,
            [
              { text: 'Home', href: '/' },
              { text: 'Reporting' },
              { text: 'Regional Snapshot', href: '/reporting/regional-snapshot' }
            ],
            'Regional Snapshot',
            <RegionalSnapshotDashboardHelp />,
            null,
            RegionalSnapshotDashboardHelp.aiContext,
            'Review a saved regional snapshot for the selected month, quarter, or fiscal year.'
          )}
        </Guard>
      </Route>

      <Route path="/template-editor">
        <Guard path="/template-editor">
          {renderContent(
            TemplateEditorDashboard,
            [{ text: 'Home', href: '/' }, { text: 'Template Editor', href: '/template-editor' }],
            'Template Editor',
            <TemplateEditorDashboardHelp />,
            (
              <SpaceBetween size="xs" direction="horizontal">
                <Button
                  iconName="add-plus"
                  onClick={() =>
                    window.dispatchEvent(new CustomEvent('templateEditor:openPalette'))
                  }
                >
                  Add widget
                </Button>
                <Button
                  iconName="refresh"
                  onClick={() =>
                    window.dispatchEvent(new CustomEvent('templateEditor:resetLayout'))
                  }
                >
                  Reset layout
                </Button>
              </SpaceBetween>
            )
          )}
        </Guard>
      </Route>

      <Route path="/modify-component/:id">
        <Guard path="/modify-component/:id">
          {renderContent(
            ModifyComponent,
            [
              { text: 'Home', href: '/' },
              { text: 'Manage Intake Steps', href: '/manage-components' },
              { text: 'Modify Intake Step', href: '/modify-component/:id' }
            ],
            'Modify Intake Step',
            <ModifyIntakeStepHelp />
          )}
        </Guard>
      </Route>

      <Route path="/manage-security-options">
        {renderContent(
          ManageSecurityOptions,
          [{ text: 'Home', href: '/' }, { text: 'Security Settings', href: '/manage-security-options' }],
          'Security Settings',
          'manageSecurityOptions'
        )}
      </Route>

      <Route path="/access-control">
        <Guard path="/manage-security-options">
          {renderContent(
            AccessControlDashboard,
            [
              { text: 'Home', href: '/' },
              { text: 'Security Settings', href: '/manage-security-options' },
              { text: 'Access Control', href: '/access-control' }
            ],
            'Access Control',
            'accessControl'
          )}
        </Guard>
      </Route>

      <Route path="/manage-components">
        <Guard path="/manage-components">
          {renderContent(
            ManageIntakeSteps,
            [{ text: 'Home', href: '/' }, { text: 'Manage Intake Steps', href: '/manage-components' }],
            'Manage Intake Steps',
            <ManageIntakeStepsHelpPanel />,
            (
              <SpaceBetween size="xs" direction="horizontal">
                <Button
                  iconName="add-plus"
                  onClick={() => window.dispatchEvent(new CustomEvent('manageComponents:openPalette'))}
                >
                  Add widget
                </Button>
                <Button
                  iconName="refresh"
                  onClick={() => window.dispatchEvent(new CustomEvent('manageComponents:resetLayout'))}
                >
                  Reset layout
                </Button>
              </SpaceBetween>
            )
          )}
        </Guard>
      </Route>

      <Route path="/case-assignment-dashboard">
        {renderContent(
          CaseAssignmentDashboard,
          [
            { text: 'Home', href: '/' },
            { text: 'Manage ISET Applications', href: '/case-assignment-dashboard' }
          ],
          'Manage ISET Applications',
          <CaseAssignmentDashboardHelp />,
          (
            <SpaceBetween size="xs" direction="horizontal">
              <Button
                iconName="add-plus"
                onClick={() => window.dispatchEvent(new CustomEvent('caseAssignment:openPalette'))}
              >
                Add widget
              </Button>
              <Button
                iconName="refresh"
                onClick={() => window.dispatchEvent(new CustomEvent('caseAssignment:resetLayout'))}
              >
                Reset layout
              </Button>
            </SpaceBetween>
          ),
          CaseAssignmentDashboardHelp.aiContext
        )}
      </Route>

      <Route path="/iset/applications/intake">
        <Guard path="/iset/applications/intake">
          {renderContent(
            ManualApplicationIntakePage,
            [
              { text: 'Home', href: '/' },
              { text: 'Manual Application Intake', href: '/iset/applications/intake' }
            ],
            'Manual Application Intake',
            <ManualApplicationIntakeHelp />,
            (
              <SpaceBetween size="xs" direction="horizontal">
                <Button
                  iconName="add-plus"
                  onClick={() => window.dispatchEvent(new CustomEvent('manualIntake:openPalette'))}
                >
                  Add widget
                </Button>
                <Button
                  iconName="refresh"
                  onClick={() => window.dispatchEvent(new CustomEvent('manualIntake:resetLayout'))}
                >
                  Reset layout
                </Button>
              </SpaceBetween>
            ),
            ManualApplicationIntakeHelp.aiContext
          )}
        </Guard>
      </Route>

      <Route path="/iset/imports/client-files">
        <Guard path="/iset/imports/client-files">
          {renderContent(
            ClientFileImportDashboard,
            [
              { text: 'Home', href: '/' },
              { text: 'Configuration', href: '/configuration-settings' },
              { text: 'Client Batch Import', href: '/iset/imports/client-files' }
            ],
            'Client Batch Import',
            <ClientFileImportDashboardHelp />,
            (
              <SpaceBetween size="xs" direction="horizontal">
                <Button
                  iconName="add-plus"
                  onClick={() =>
                    window.dispatchEvent(new CustomEvent('clientFileImport:openPalette'))
                  }
                >
                  Add widget
                </Button>
                <Button
                  iconName="refresh"
                  onClick={() =>
                    window.dispatchEvent(new CustomEvent('clientFileImport:resetLayout'))
                  }
                >
                  Reset layout
                </Button>
              </SpaceBetween>
            ),
            ClientFileImportDashboardHelp.aiContext,
            'Backload participant spreadsheets into client files with dry-run validation and duplicate matching.'
          )}
        </Guard>
      </Route>

      <Route path="/esdc/overview">
        <Guard roles={['System Administrator', 'NWAC Administrator']} path="/esdc/overview">
          {renderContent(
            EsdcSubmissionsOverviewPage,
            [
              { text: 'Home', href: '/' },
              { text: 'ESDC Submissions', href: '/esdc/overview' }
            ],
            'ESDC Submissions Overview',
            <EsdcOverviewHelp />,
            (
              <SpaceBetween size="xs" direction="horizontal">
                <Button
                  iconName="add-plus"
                  onClick={() =>
                    window.dispatchEvent(new CustomEvent('esdcOverview:openPalette'))
                  }
                >
                  Add widget
                </Button>
                <Button
                  iconName="refresh"
                  onClick={() =>
                    window.dispatchEvent(new CustomEvent('esdcOverview:resetLayout'))
                  }
                >
                  Reset layout
                </Button>
              </SpaceBetween>
            ),
            EsdcOverviewHelp.aiContext
          )}
        </Guard>
      </Route>

      <Route path="/esdc/participants" exact>
        <Guard roles={['System Administrator', 'NWAC Administrator']} path="/esdc/participants">
          {renderContent(
            EsdcParticipantSubmissionsPage,
            [
              { text: 'Home', href: '/' },
              { text: 'ESDC Submissions', href: '/esdc/overview' },
              { text: 'ILMP Submissions & Exports', href: '/esdc/participants' }
            ],
            'ILMP Submissions & Exports',
            <EsdcParticipantsHelp />,
            (
              <SpaceBetween size="xs" direction="horizontal">
                <Button
                  iconName="add-plus"
                  onClick={() =>
                    window.dispatchEvent(new CustomEvent('esdcParticipants:openPalette'))
                  }
                >
                  Add widget
                </Button>
                <Button
                  iconName="refresh"
                  onClick={() =>
                    window.dispatchEvent(new CustomEvent('esdcParticipants:resetLayout'))
                  }
                >
                  Reset layout
                </Button>
              </SpaceBetween>
            ),
            EsdcParticipantsHelp.aiContext
          )}
        </Guard>
      </Route>

      <Route path="/esdc/participants/:clientId">
        <Guard roles={['System Administrator', 'NWAC Administrator']} path="/esdc/participants">
          {renderContent(
            ParticipantWorkspacePage,
            [
              { text: 'Home', href: '/' },
              { text: 'ESDC Submissions', href: '/esdc/overview' },
              { text: 'Participant Workspace', href: '#' }
            ],
            'Participant Submission Workspace',
            <EsdcSubmissionDashboardHelp />,
            (
              <SpaceBetween size="xs" direction="horizontal">
                <Button
                  iconName="add-plus"
                  onClick={() =>
                    window.dispatchEvent(new CustomEvent('esdcParticipantWorkspace:openPalette'))
                  }
                >
                  Add widget
                </Button>
                <Button
                  iconName="refresh"
                  onClick={() =>
                    window.dispatchEvent(new CustomEvent('esdcParticipantWorkspace:resetLayout'))
                  }
                >
                  Reset layout
                </Button>
              </SpaceBetween>
            ),
            EsdcSubmissionDashboardHelp.aiContext
          )}
        </Guard>
      </Route>

      <Route path="/esdc/reporting">
        <Guard roles={['System Administrator', 'NWAC Administrator']} path="/esdc/reporting">
          {renderContent(
            EsdcReportingPackagesPage,
            [
              { text: 'Home', href: '/' },
              { text: 'ESDC Submissions', href: '/esdc/overview' },
              { text: 'Reporting', href: '/esdc/reporting' }
            ],
            'Reporting Packages',
            <EsdcReportingHelp />,
            (
              <SpaceBetween size="xs" direction="horizontal">
                <Button
                  iconName="add-plus"
                  onClick={() =>
                    window.dispatchEvent(new CustomEvent('esdcReporting:openPalette'))
                  }
                >
                  Add widget
                </Button>
                <Button
                  iconName="refresh"
                  onClick={() =>
                    window.dispatchEvent(new CustomEvent('esdcReporting:resetLayout'))
                  }
                >
                  Reset layout
                </Button>
              </SpaceBetween>
            ),
            EsdcReportingHelp.aiContext
          )}
        </Guard>
      </Route>

      <Route path="/iset/cases">
        <Guard path="/iset/cases">
          {renderContent(
            PortfolioDashboardPage,
            [
              { text: 'Home', href: '/' },
              { text: 'ISET Clients', href: '/iset/cases' }
            ],
            'ISET Clients',
            <PortfolioDashboardHelp />,
            (
              <SpaceBetween size="xs" direction="horizontal">
                <Button
                  iconName="add-plus"
                  onClick={() => window.dispatchEvent(new CustomEvent("iset-portfolio:openPalette"))}
                >
                  Add widget
                </Button>
                <Button
                  iconName="refresh"
                  onClick={() => window.dispatchEvent(new CustomEvent("iset-portfolio:resetLayout"))}
                >
                  Reset layout
                </Button>
              </SpaceBetween>
            ),
            PortfolioDashboardHelp.aiContext
          )}
        </Guard>
      </Route>

      <Route path="/iset/payments">
        <Guard path="/iset/payments">
          {renderContent(
            ProgramPaymentsPage,
            [
              { text: 'Home', href: '/' },
              { text: 'ISET Clients', href: '/iset/cases' },
              { text: 'Payments', href: '/iset/payments' }
            ],
            'Payments',
            <Box variant="p">Manage payment packets, upload evidence, and submit requests to finance.</Box>,
            (
              <SpaceBetween size="xs" direction="horizontal">
                <Button
                  iconName="add-plus"
                  onClick={() => window.dispatchEvent(new CustomEvent("programPayments:openPalette"))}
                >
                  Add widget
                </Button>
                <Button
                  iconName="refresh"
                  onClick={() => window.dispatchEvent(new CustomEvent("programPayments:resetLayout"))}
                >
                  Reset layout
                </Button>
              </SpaceBetween>
            )
          )}
        </Guard>
      </Route>

      <Route path="/contact-communications">
        <Guard path="/contact-communications">
          {renderContent(
            ContactCommunicationsDashboard,
            [
              { text: 'Home', href: '/' },
              { text: 'Manage ISET Applications', href: '/case-assignment-dashboard' },
              { text: 'Contact Communications', href: '/contact-communications' }
            ],
            'Contact Communications',
            <ContactCommunicationsHelp />,
            (
              <SpaceBetween size="xs" direction="horizontal">
                <Button
                  iconName="add-plus"
                  onClick={() =>
                    window.dispatchEvent(new CustomEvent("contactCommunications:openPalette"))
                  }
                >
                  Add widget
                </Button>
                <Button
                  iconName="refresh"
                  onClick={() =>
                    window.dispatchEvent(new CustomEvent("contactCommunications:resetLayout"))
                  }
                >
                  Reset layout
                </Button>
              </SpaceBetween>
            ),
            ContactCommunicationsHelp.aiContext
          )}
        </Guard>
      </Route>

      <Route path="/messages">
        <Guard path="/messages">
          {renderContent(
            MessagesDashboardPage,
            [
              { text: 'Home', href: '/' },
              { text: 'Messages', href: '/messages' },
            ],
            'Messages',
            <Box variant="p">Internal secure messaging for staff.</Box>
          )}
        </Guard>
      </Route>

      <Route path="/job-bank-search">
        <Guard path="/job-bank-search">
          {renderContent(
            JobBankSearchPage,
            [
              { text: 'Home', href: '/' },
              { text: 'Job Search', href: '/job-bank-search' },
            ],
            'Job Bank Search',
            <JobBankSearchHelp />,
            null,
            JobBankSearchHelp.aiContext
          )}
        </Guard>
      </Route>

      <Route path="/cases/:caseId/appeals">
        <Guard path="/cases/:caseId">
          <AppealsEntry />
        </Guard>
      </Route>

      <Route path="/cases/:caseId">
        <Guard path="/cases/:caseId">
          {renderContent(
            CaseWorkspacePage,
            [
              { text: 'Home', href: '/' },
              { text: 'ISET Clients', href: '/iset/cases' },
              { text: 'Case workspace' }
            ],
            'Case Workspace',
            <CaseWorkspaceHelp />,
            (
              <SpaceBetween size="xs" direction="horizontal">
                <Button
                  iconName="external"
                  onClick={() => window.location.assign('/job-bank-search')}
                >
                  Job Search
                </Button>
                <Button
                  iconName="add-plus"
                  onClick={() => window.dispatchEvent(new CustomEvent("iset-case-workspace:openPalette"))}
                >
                  Add widget
                </Button>
                <Button
                  iconName="refresh"
                  onClick={() => window.dispatchEvent(new CustomEvent("iset-case-workspace:resetLayout"))}
                >
                  Reset layout
                </Button>
              </SpaceBetween>
            ),
            CaseWorkspaceHelp.aiContext
          )}
        </Guard>
      </Route>

      <Route path="/application-case/:id">
        <Guard path="/application-case/:id">
          {renderContent(
            ApplicationCaseDashboard,
            [
              { text: 'Home', href: '/' },
              { text: 'Manage ISET Applications', href: '/case-assignment-dashboard' },
              { text: 'Assessment' }
            ],
            'ISET Application Assessment',
            <ApplicationCaseDashboardHelp />,
            (
              <SpaceBetween direction="horizontal" size="xs">
                <Button
                  iconName="external"
                  onClick={() => window.location.assign('/job-bank-search')}
                >
                  Job Search
                </Button>
                <Button
                  iconName="add-plus"
                  onClick={() => window.dispatchEvent(new CustomEvent("applicationAssessment:openPalette"))}
                >
                  Add widget
                </Button>
                <Button
                  iconName="refresh"
                  onClick={() => window.dispatchEvent(new CustomEvent("applicationAssessment:resetLayout"))}
                >
                  Reset layout
                </Button>
              </SpaceBetween>
            ),
            ApplicationCaseDashboardHelp.aiContext
          )}
        </Guard>
      </Route>

      <Route path="/nwac-hub-management">
        <Guard path="/nwac-hub-management">
          {renderContent(
            NWACHubManagementDashboard,
            [
              { text: 'Home', href: '/' },
              { text: 'NWAC Hub Management', href: '/nwac-hub-management' }
            ],
            'NWAC Hub Management',
            'nwacHubManagement'
          )}
        </Guard>
      </Route>

      <Route path="/finance/overview">
        <Guard path="/finance/overview">
          {renderContent(
            FinanceOverviewPage,
            [
              { text: 'Home', href: '/' },
              { text: 'Budgets and Finance', href: '/finance/overview' }
            ],
            'Finance Overview',
            <FinanceOverviewHelp />,
            (
              <SpaceBetween direction="horizontal" size="s">
                <Button iconName="add-plus" onClick={() => window.dispatchEvent(new CustomEvent("finance:openPalette"))}>
                  Add widget
                </Button>
                <Button iconName="refresh" onClick={() => window.dispatchEvent(new CustomEvent("finance:resetLayout"))}>
                  Reset layout
                </Button>
              </SpaceBetween>
            ),
            FinanceOverviewHelp.aiContext
          )}
        </Guard>
      </Route>

      <Route path="/finance/budgets/planning">
        <Guard path="/finance/budgets/planning">
          {renderContent(
            FinanceBudgetsPage,
            [
              { text: 'Home', href: '/' },
              { text: 'Budgets and Finance', href: '/finance/overview' },
              { text: 'Budget Planning', href: '/finance/budgets/planning' }
            ],
            'Budget Planning',
            <FinanceBudgetPlanningHelp />,
            (
              <SpaceBetween direction="horizontal" size="s">
                <Button
                  iconName="add-plus"
                  onClick={() => window.dispatchEvent(new CustomEvent("financeBudgets:openPalette"))}
                >
                  Add widget
                </Button>
                <Button
                  iconName="refresh"
                  onClick={() => window.dispatchEvent(new CustomEvent("financeBudgets:resetLayout"))}
                >
                  Reset layout
                </Button>
              </SpaceBetween>
            ),
            FinanceBudgetPlanningHelp.aiContext
          )}
        </Guard>
      </Route>
      <Route path="/finance/budgets">
        <Guard path="/finance/budgets">
          {renderContent(PublishedBudgetsPage,
            [{ text: 'Home', href: '/' }, { text: 'Budgets and Finance', href: '/finance/overview' }, { text: 'Budgets', href: '/finance/budgets' }],
            'Budgets', <FinanceBudgetsHelp />,
            <SpaceBetween direction="horizontal" size="s">
              <Button iconName="add-plus" onClick={() => window.dispatchEvent(new CustomEvent('publishedBudgets:openPalette'))}>Add widget</Button>
              <Button iconName="refresh" onClick={() => window.dispatchEvent(new CustomEvent('publishedBudgets:resetLayout'))}>Reset layout</Button>
            </SpaceBetween>, FinanceBudgetsHelp.aiContext)}
        </Guard>
      </Route>
      <Route path="/finance/expenses">
        <Guard path="/finance/expenses">
          {renderContent(FinanceExpensesPage,
            [{ text: 'Home', href: '/' }, { text: 'Budgets and Finance', href: '/finance/overview' }, { text: 'Expenses', href: '/finance/expenses' }],
            'Expenses', <FinanceExpensesHelp />,
            <SpaceBetween direction="horizontal" size="s">
              <Button iconName="add-plus" onClick={() => window.dispatchEvent(new CustomEvent('financeExpenses:openPalette'))}>Add widget</Button>
              <Button iconName="refresh" onClick={() => window.dispatchEvent(new CustomEvent('financeExpenses:resetLayout'))}>Reset layout</Button>
            </SpaceBetween>, FinanceExpensesHelp.aiContext)}
        </Guard>
      </Route>
      <Route path="/finance/salaries">
        <Guard path="/finance/salaries">
          {renderContent(
            FinanceSalariesPage,
            [
              { text: 'Home', href: '/' },
              { text: 'Budgets and Finance', href: '/finance/overview' },
              { text: 'Salaries', href: '/finance/salaries' }
            ],
            'Salaries',
            <FinanceSalariesHelp />,
            (
              <SpaceBetween size="xs" direction="horizontal">
                <Button
                  iconName="add-plus"
                  onClick={() =>
                    window.dispatchEvent(new CustomEvent("financeSalaries:openPalette"))
                  }
                >
                  Add widget
                </Button>
                <Button
                  iconName="refresh"
                  onClick={() =>
                    window.dispatchEvent(new CustomEvent("financeSalaries:resetLayout"))
                  }
                >
                  Reset layout
                </Button>
              </SpaceBetween>
            ),
            FinanceSalariesHelp.aiContext
          )}
        </Guard>
      </Route>
      <Route path="/finance/payments">
        <Guard path="/finance/payments">
          {renderContent(
            FinancePaymentsPage,
            [
              { text: 'Home', href: '/' },
              { text: 'Budgets and Finance', href: '/finance/overview' },
              { text: 'Payments', href: '/finance/payments' }
            ],
            'Payments',
            <FinancePaymentsHelp />,
            (
              <SpaceBetween size="xs" direction="horizontal">
                <Button
                  iconName="add-plus"
                  onClick={() =>
                    window.dispatchEvent(new CustomEvent("financePayments:openPalette"))
                  }
                >
                  Add widget
                </Button>
                <Button
                  iconName="refresh"
                  onClick={() =>
                    window.dispatchEvent(new CustomEvent("financePayments:resetLayout"))
                  }
                >
                  Reset layout
                </Button>
              </SpaceBetween>
            ),
            FinancePaymentsHelp.aiContext
          )}
        </Guard>
      </Route>

      <Route path="/finance/allocations">
        <Guard path="/finance/allocations">
          {renderContent(
            FinanceAllocationsPage,
            [
              { text: 'Home', href: '/' },
              { text: 'Budgets and Finance', href: '/finance/overview' },
              { text: 'Allocations & Transfers', href: '/finance/allocations' }
            ],
            'Allocations & Transfers',
            <FinanceAllocationsHelp />,
            (
              <SpaceBetween size="xs" direction="horizontal">
                <Button
                  iconName="add-plus"
                  onClick={() =>
                    window.dispatchEvent(new CustomEvent("financeAllocations:openPalette"))
                  }
                >
                  Add widget
                </Button>
                <Button
                  iconName="refresh"
                  onClick={() =>
                    window.dispatchEvent(new CustomEvent("financeAllocations:resetLayout"))
                  }
                >
                  Reset layout
                </Button>
              </SpaceBetween>
            ),
            FinanceAllocationsHelp.aiContext
          )}
        </Guard>
      </Route>

      <Route path="/finance/reconciliation">
        <Guard path="/finance/reconciliation">
          {renderContent(
            FinanceReconciliationPage,
            [
              { text: 'Home', href: '/' },
              { text: 'Budgets and Finance', href: '/finance/overview' },
              { text: 'Reconciliation', href: '/finance/reconciliation' }
            ],
            'Reconciliation',
            <FinanceReconciliationHelp />,
            (
              <SpaceBetween size="xs" direction="horizontal">
                <Button
                  iconName="add-plus"
                  onClick={() =>
                    window.dispatchEvent(new CustomEvent("financeReconciliation:openPalette"))
                  }
                >
                  Add widget
                </Button>
                <Button
                  iconName="refresh"
                  onClick={() =>
                    window.dispatchEvent(new CustomEvent("financeReconciliation:resetLayout"))
                  }
                >
                  Reset layout
                </Button>
              </SpaceBetween>
            ),
            FinanceReconciliationHelp.aiContext
          )}
        </Guard>
      </Route>

      <Route path="/finance/reports">
        <Guard path="/finance/reports">
          {renderContent(
            FinanceReportsPage,
            [
              { text: 'Home', href: '/' },
              { text: 'Budgets and Finance', href: '/finance/overview' },
              { text: 'Financial Reports', href: '/finance/reports' }
            ],
            'Financial Reports',
            <FinanceReportsHelp />,
            null,
            FinanceReportsHelp.aiContext
          )}
        </Guard>
      </Route>

      <Route path="/finance/monitoring">
        <Guard path="/finance/monitoring">
          {renderContent(
            FinanceMonitoringPage,
            [
              { text: 'Home', href: '/' },
              { text: 'Budgets and Finance', href: '/finance/overview' },
              { text: 'Monitoring & Evidence', href: '/finance/monitoring' }
            ],
            'Monitoring & Evidence',
            <FinanceMonitoringHelp />,
            (
              <SpaceBetween size="xs" direction="horizontal">
                <Button
                  iconName="add-plus"
                  onClick={() =>
                    window.dispatchEvent(new CustomEvent("financeMonitoring:openPalette"))
                  }
                >
                  Add widget
                </Button>
                <Button
                  iconName="refresh"
                  onClick={() =>
                    window.dispatchEvent(new CustomEvent("financeMonitoring:resetLayout"))
                  }
                >
                  Reset layout
                </Button>
              </SpaceBetween>
            ),
            FinanceMonitoringHelp.aiContext
          )}
        </Guard>
      </Route>

      <Route path="/finance/forecasting">
        <Guard path="/finance/forecasting">
          {renderContent(
            FinanceForecastingPage,
            [
              { text: 'Home', href: '/' },
              { text: 'Budgets and Finance', href: '/finance/overview' },
              { text: 'Forecasting & Scenarios', href: '/finance/forecasting' }
            ],
            'Forecasting & Scenarios',
            <FinanceForecastingHelp />,
            (
              <SpaceBetween size="xs" direction="horizontal">
                <Button
                  iconName="add-plus"
                  onClick={() =>
                    window.dispatchEvent(new CustomEvent("financeForecasting:openPalette"))
                  }
                >
                  Add widget
                </Button>
                <Button
                  iconName="refresh"
                  onClick={() =>
                    window.dispatchEvent(new CustomEvent("financeForecasting:resetLayout"))
                  }
                >
                  Reset layout
                </Button>
              </SpaceBetween>
            ),
            FinanceForecastingHelp.aiContext
          )}
        </Guard>
      </Route>

      <Route path="/finance/settings">
        <Guard path="/finance/settings">
          {renderContent(
            FinanceSettingsPage,
            [
              { text: 'Home', href: '/' },
              { text: 'Budgets and Finance', href: '/finance/overview' },
              { text: 'Finance Settings', href: '/finance/settings' }
            ],
            'Finance Settings',
            'financeSettings',
            (
              <SpaceBetween size="xs" direction="horizontal">
                <Button
                  iconName="add-plus"
                  onClick={() =>
                    window.dispatchEvent(new CustomEvent("financeSettings:openPalette"))
                  }
                >
                  Add widget
                </Button>
                <Button
                  iconName="refresh"
                  onClick={() =>
                    window.dispatchEvent(new CustomEvent("financeSettings:resetLayout"))
                  }
                >
                  Reset layout
                </Button>
              </SpaceBetween>
            )
          )}
        </Guard>
      </Route>

      <Route path="/documentation">
        {renderContent(
          DocumentationLibrary,
          [{ text: 'Home', href: '/' }, { text: 'Guidance Library', href: '/documentation' }],
          'Guidance Library',
          'documentationLibrary',
          (
            <SpaceBetween size="xs" direction="horizontal">
              <Button
                iconName="add-plus"
                onClick={() => window.dispatchEvent(new CustomEvent('documentation:openPalette'))}
              >
                Add widget
              </Button>
              <Button
                iconName="refresh"
                onClick={() => window.dispatchEvent(new CustomEvent('documentation:resetLayout'))}
              >
                Reset layout
              </Button>
            </SpaceBetween>
          ),
          '',
          "Quick links to guidance resources and reference guides you use most often. Each card shows what the doc covers, who it's for, and where to open it."
        )}
      </Route>

      <Route path="/tutorials-dashboard">
        <Guard path="/tutorials-dashboard">
          {renderContent(
            TutorialsDashboardPage,
            [
              { text: 'Home', href: '/' },
              { text: 'Support', href: '/help-support-dashboard' },
              { text: 'Tutorials', href: '/tutorials-dashboard' }
            ],
            'Tutorials',
            <TutorialsDashboardHelp />,
            null,
            TutorialsDashboardHelp.aiContext,
            'Training shorts and guided tours.'
          )}
        </Guard>
      </Route>

      <Route path="/support/bugs-change-requests">
        <Guard path="/support/bugs-change-requests">
          {renderContent(
            BugsChangeRequestsDashboard,
            [
              { text: 'Home', href: '/' },
              { text: 'Support', href: '/help-support-dashboard' },
              { text: 'Bugs and Change Requests', href: '/support/bugs-change-requests' }
            ],
            'Bugs and Change Requests',
            <HomeSystemAdminFeedbackQueueHelp />,
            null,
            HomeSystemAdminFeedbackQueueHelp.aiContext,
            'Review, triage, and update internal PATH bug reports and change requests.'
          )}
        </Guard>
      </Route>

      <Route path="/">
        {renderContent(
          AdminDashboard,
          [{ text: 'Home', href: '/' }],
          'NWAC ISET Homepage',
          <HomeDashboardHelp />,
          (
            <Hotspot hotspotId="home-layout-controls" direction="bottom">
              <SpaceBetween size="xs" direction="horizontal">
                <Button iconName="add-plus" onClick={() => window.dispatchEvent(new CustomEvent('home:openPalette'))}>
                  Add widget
                </Button>
                <Button iconName="refresh" onClick={() => window.dispatchEvent(new CustomEvent('home:resetLayout'))}>
                  Reset layout
                </Button>
              </SpaceBetween>
            </Hotspot>
          ),
          HomeDashboardHelp.aiContext,
          '',
          'home-overview',
          'home-info-link'
        )}
      </Route>
    </Switch>
  );
};

export default AppRoutes;





